// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// export const productsApi = createApi({
//   reducerPath: "productApi",
//   baseQuery: fetchBaseQuery({ 
//     baseUrl: import.meta.env.VITE_API + "products",
//     prepareHeaders: (headers, { getState }) => {
//       headers.set("Content-Type", "application/json");
//       return headers;
//     },
//   }),
//   endpoints: (builder) => ({
//     getProducts: builder.mutation({
//       query: (code) => ({
//         url: code?`?code=${code}`:"",
//         method: "GET",
//       }),
//     }),
//   }),
// });

// export const { useGetProductsQuery } = productsApi;
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const productsApi = createApi({
  reducerPath: "productApi",
  baseQuery: fetchBaseQuery({ 
    baseUrl: import.meta.env.VITE_API + "products",
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: (query) => ({
        url: query ? query : "",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetProductsQuery } = productsApi;